// @flow

import { getProject } from '../../../HttpRequests/projects';
import { loadProject } from '../State/project';
import { setFetching } from '../State/fetching';
import { getProps } from '../props';
import handleException from '../../../Core/Helpers/handleException';
import { getProjectFeedback } from '../../../HttpRequests/projectFeedback';

export default () => async (dispatch: Function) => {

  try {

    const { id } = getProps().match.params;

    const params = {};

    params.include = [
      'clientSite',
      'clientSite.client',
      'clientSite.client.clientContacts',
      'clientContact',
      'accountManager',
      'contractsManager',
      'otherContractsManager',
      'supervisor',
      'estimates',
      'orders',
      'valuationDates',
      'valuations',
      'valuations.activeInvoices',
      'invoices',
      'invoices.valuation',
      'invoices.retentionPayment',
      'retentionPayments',
      'retentionPayments.activeInvoices',
      'ramsRecords',

    ].join();

    params.append = [
      'status',
      'phase',
      'action_statuses',
      'updatable_fields',
      'total_valuation_certificate_amount',
      'total_valuation_certificate_amount_difference',
      'hasPendingFeedback',
      'hasCompletedFeedback'
    ].join();

    dispatch(setFetching(true));

    const response = await getProject({ id, params });

    const project = response.data.data;

    dispatch(loadProject(project));

    // Load feedback for this project
    try {
      const feedbackResponse = await getProjectFeedback({ id: project.id });
      dispatch({ type: 'SET_FEEDBACK', payload: feedbackResponse.data.feedback });
    } catch (feedbackError) {
      console.error('Error loading feedback:', feedbackError);
      dispatch({ type: 'SET_FEEDBACK', payload: [] });
    }

    dispatch(setFetching(false));

  } catch (error) {

    handleException(error);

  }
}
